import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Projects from './pages/Projects';
import ProjectFocus from './pages/ProjectFocus';
import Contact from './pages/Contact';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './styles.scss';
import "./classes.scss";

function App() {
  return (
    <div className="App flex-body-column medium-gap">
      <Navbar />
      <Routes className="routes">
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:title" element={<ProjectFocus />} />
        <Route path="/contact" element={<Contact />} />
      </Routes> 
      <Footer />
    </div>
  );
}

export default App;